
import IztOpptyCard from './src/izt-oppty-card.vue'

IztOpptyCard.install = Vue => {
  Vue.component(IztOpptyCard.name, IztOpptyCard)
}

export default IztOpptyCard
